export const sortChats = (a: any, b: any) =>
    new Date(b.date).getTime() - new Date(a.date).getTime();